<script>
  import {onMount} from 'svelte';
  import {userApi} from '@/api/user';
  import {referral$} from '@/store/referral';
  import {getAuthRedirectUri} from '@/modules/web3/social-trade/utils';
  import '../access-google/access-styled.scss';

  let className = '';
  export {className as class};
  export let width = 48;
  export let target = '';
  export let entrance = '';
  export let next = '';
  export let iconInfo = {
    defaultIcon: 'https://img.phemex.com/v1/4a3a548f-672d-4f29-aeb3-234d8188a6a0/login-twitter.png',
    hoverIcon: 'https://img.phemex.com/v1/678f295f-dd51-4a10-86df-c06d1f7a181a/login-twitter-hover.png',
    alt: 'icon',
    visibleTitle: false,
  };

  let ready = false;
  let loading = false;

  onMount(() => {
    ready = true;
  });

  async function handleBtnClick() {
    const {code} = $referral$;
    const {data} = await userApi.getTwitterClientId();
    const clientId = data.msg;
    const challenge = randomString();
    const redirectUri = getAuthRedirectUri();
    const state = encodeURIComponent(`${challenge}#${next}#${target || ''}#${code}#${entrance}`);
    const url = `https://twitter.com/i/oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=users.read%20follows.read%20tweet.read&state=${state}&code_challenge=${challenge}&code_challenge_method=plain`;
    window.location.assign(url);
  }

  function randomString(count = 32) {
    const t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz1234567890';
    const len = t.length;
    const arr = [];
    for (let i = 0; i < count; i++) {
      arr.push(t.charAt(Math.floor(Math.random() * len)));
    }
    return arr.join('');
  }
</script>

<style>
  .loading {
    cursor: not-allowed;
    opacity: 0.5;
  }
</style>

<section class="wallet-connect-box">
  <div class="pr f16 df cp {className}" style="padding: 0" on:click={handleBtnClick}>
    <div class="df fdc jcc aic" class:loading={!ready || loading}>
      <div class="img df jcc aic pr">
        <img {width} height={width} data-replace-icon="false" src={iconInfo.defaultIcon} alt={iconInfo.alt} />
        <img {width} height={width} class="white" data-replace-icon="false" src={iconInfo.hoverIcon} alt={iconInfo.alt} />
      </div>
      {#if iconInfo.visibleTitle}
        <div class="con mt12 f12 lh18 T3 sm:hidden">Twitter</div>
      {/if}
    </div>
  </div>
</section>
